import React, { useState } from 'react'
import { auth } from '../firebase';
import {sendPasswordResetEmail} from 'firebase/auth';
import { useNavigate } from 'react-router-dom';

function Forgot() {
    const[email,setemail]=useState('');
    const history = useNavigate();
    const handleSubmit = (e) =>{
        e.preventDefault();
        try{
            sendPasswordResetEmail(auth,email,{
                url: 'http://localhost/login',
            })
            window.M.toast({html:`Mail sent successfully to ${email}`,classes:'green'})
            history('/login')}
            catch(err){
             window.M.toast({html:err.message,classes:'red'})}
        }
  return (
    <div className='center container'>
        <h1>Please Login</h1>
        <form onSubmit={e=>handleSubmit(e)}>
            <div className="input-field">
                <input type="email" name="email" value={email} onChange={e=>setemail(e.target.value)} placeholder='Enter your Email' />
            </div>
                <button className='btn blue' type='submit'>Send</button>
        </form>
        </div>
  )
}

export default Forgot